import DrupalImage from '@commons/components/Image/Drupal';
import type { DrupalImage as DrupalImageType, DrupalParagraph } from '@commons/types/drupal';

// Type definition for the Image paragraph properties.

type Props = DrupalParagraph & {
  image: DrupalImageType;
};

/**
 * Image paragraph component.
 */

const ImageParagraph = ({ image }: Props) => {
  return <DrupalImage {...image} />;
};

export default ImageParagraph;
